import { z } from 'zod';
import {
  GRIFFONNE_DIFFICULTIES,
  GRIFFONNE_MAX_DRAW_SEC,
  GRIFFONNE_MAX_PLAYERS,
  GRIFFONNE_MAX_ROUNDS,
  GRIFFONNE_MIN_DRAW_SEC,
  GRIFFONNE_MIN_PLAYERS,
  GRIFFONNE_MIN_ROUNDS,
  GRIFFONNE_WORD_CHOICES,
} from './constants.js';

/**
 * Config d'une PARTIE PRIVÉE (le salon commun ignore et fige les défauts). Toutes
 * les bornes sont validées serveur (spec §5.1). `.strict()` : clés inconnues rejetées.
 */
export const griffonneConfigSchema = z
  .object({
    totalRounds: z.number().int().min(GRIFFONNE_MIN_ROUNDS).max(GRIFFONNE_MAX_ROUNDS).optional(),
    drawTimeSec: z.number().int().min(GRIFFONNE_MIN_DRAW_SEC).max(GRIFFONNE_MAX_DRAW_SEC).optional(),
    maxPlayers: z.number().int().min(GRIFFONNE_MIN_PLAYERS).max(GRIFFONNE_MAX_PLAYERS).optional(),
    difficulties: z.array(z.enum(GRIFFONNE_DIFFICULTIES)).nonempty().optional(),
    revealHints: z.boolean().optional(),
  })
  .strict();

export type GriffonneConfigInput = z.infer<typeof griffonneConfigSchema>;

/** Choix d'un mot parmi les `GRIFFONNE_WORD_CHOICES` proposés (dessinateur). */
export const griffonnePickWordSchema = z
  .object({
    index: z.number().int().min(0).max(GRIFFONNE_WORD_CHOICES - 1),
  })
  .strict();

export type GriffonnePickWordInput = z.infer<typeof griffonnePickWordSchema>;
